import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {ItemAnimationObject} from '@PosterWhiteboard/animation/animation.class';

export function useGetKeyFromItemOutroAnimation<T extends keyof ItemAnimationObject>(key: T): ItemAnimationObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item && 'outroAnimation' in item && item.outroAnimation[key] !== undefined) {
      return item.outroAnimation[key];
    }

    return undefined;
  });
}
